export default "__VITE_ASSET__7f36bade__"